import React from 'react';
import TopicsPageLayout from '../components/TopicsPageLayout.jsx';
import TopicsRouter from '../components/TopicsRouter.jsx';
import topicData from './quality.json';

const Quality = () => {
  return (
    <div className="topic-page-container">
        <TopicsPageLayout
            
            description="Quality control, standards, and excellence vocabulary. B2 level English exercises with grammar, reading, and discussion."
            level="B2"
            title="Quality"
            image="/Images/fashion.webp"
            seoTitle="Free English Lesson Plans: Quality"
            seoDescription="Quality control, standards, and excellence vocabulary. B2 level English exercises with grammar, reading, and discussion."
        >
            {topicData.map((section, index) => (
                <div key={index} className="lesson-section-wrapper">
                    <TopicsRouter sectionData={section} />
                </div>
            ))}
        </TopicsPageLayout>
    </div>
  );
};

export default Quality;


